var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow rounded-1"},[_c('h2',{staticClass:"text-center pt-3"},[_vm._v("Jumlah Penerima Sertifikat Penghargaan Per Provinsi ("+_vm._s(_vm.filterTahun)+")")]),_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }